import slug from 'slug'
import humanCase from 'humanize-string'

export default {
	methods: {
		spinalCase (string) {
			return slug(string)
		},
		humanCase (string) {
			return humanCase(string)
		}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/strings.js